import React from "react";
import PropTypes from "prop-types";
import ButtonGroup from "../ButtonGroup";
import dictionary from "../../../dictionary";
import Tooltip from "@material-ui/core/Tooltip";

import styles from "./button-group.module.scss";

function Quality(props) {
  const {name, content, onChange, current} = props;
  return (
    <div className={styles.root}>
      <ButtonGroup
        current={current}
        buttons={content}
        onChange={(value) => onChange(name, value)}
        renderButton={({value, difference}) =>
          value === `premium` ? (
            <Tooltip
              title={
                <div>
                  <h4>3 отличия премиальных футболок:</h4>
                  <p style={{fontSize: `13px`}}>
                    1) высокая плотность материала 160гр <br />
                    2) повышенная гладкость за счёт дополнительной обрабоки от
                    ворса
                    <br />
                    3) малоусадочное полотно - футболка не садится после стирки
                    {` `}
                  </p>
                </div>
              }
            >
              <span className={styles.value}>
                {dictionary.item[value]}
                {` `}
                {value !== current && difference && (
                  <span className={styles.difference}>
                    {difference > 0 && `+`}
                    {difference}₽
                  </span>
                )}
              </span>
            </Tooltip>
          ) : (
            <span className={styles.value}>
              {dictionary.item[value]}
              {` `}
              {value !== current && difference && (
                <span className={styles.difference}>
                  {difference > 0 && `+`}
                  {difference}₽
                </span>
              )}
            </span>
          )
        }
      />
      <span className={styles.label}>– выберите качество</span>
    </div>
  );
}

Quality.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      difference: PropTypes.number
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func
};

export default Quality;
